export const t_global_breakpoint_height_2xl = {
  "name": "--pf-t--global--breakpoint--height--2xl",
  "value": "80rem",
  "var": "var(--pf-t--global--breakpoint--height--2xl)"
};
export default t_global_breakpoint_height_2xl;